import Box from '@mui/material/Box';
import RemediationBox from '../RemediationBox';
import { REMEDIATION_CONSTANTS } from '../NRRemediation.constants';
import React from 'react';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import { Controller, useFormContext } from 'react-hook-form';
import TextField from '@mui/material/TextField';

function NRLicenseIssueRemediationStepTwo() {
  const { control, watch } = useFormContext();
  const form = watch();
  return (
    <Box my={5}>
      <Box>
        <RemediationBox
          title={REMEDIATION_CONSTANTS.STATUS.LABELS[form.status]}
          optValue={REMEDIATION_CONSTANTS.STATUS.VALUES[form.status]}
          subtitle={REMEDIATION_CONSTANTS.STATUS.DESCRIPTIONS[form.status]}
          showAlert={REMEDIATION_CONSTANTS.STATUS.SHOW_ALERT[form.status]}
          avoidSelection={true}
        />
      </Box>
      <Box mt={2}>
        <Typography variant={'body2'} sx={{ marginBottom: 2 }} color={'textSecondary'}>
          Optional Details
        </Typography>
        <FormControl fullWidth={true} sx={{ overflowX: 'auto' }}>
          <Controller
            control={control}
            id={'remediation-description'}
            name={'description'}
            required={false}
            render={({ field: { onChange, value } }) => (
              <TextField
                multiline={true}
                minRows={5}
                maxRows={5}
                id="table-filters"
                placeholder={'Remediation detail...'}
                value={value}
                color={'secondary'}
                onChange={onChange}
                variant="outlined"
                size="small"
              />
            )}
          />
        </FormControl>
      </Box>
    </Box>
  );
}

export default NRLicenseIssueRemediationStepTwo;
